// extracted by mini-css-extract-plugin
export default {"label":"draggableSettingItem_label__aEWvU","toggle":"draggableSettingItem_toggle__vXrJH","handle":"draggableSettingItem_handle__F4qYC"};